module.exports = __webpack_public_path__ + "src/assets/img/bg.f783f308.png";